<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="when-was-the-last-time-you-listened-to-the-stories-of-others">
<h1>When was the last time you listened to the stories of others?</h1>
<p>Question put to the sick by a Native American Medicine Man.</p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?23e833ac